/**
 * `?next=` parametresi — ACIK YONLENDIRME (open redirect) korumasi.
 *
 * Giris ekrani, kullaniciyi giristen once gitmek istedigi yere birakir. Bu
 * deger ADRES CUBUGUNDAN gelir, yani saldirgan kontrolunde: dogrulanmadan
 * kullanilirsa `/giris?next=https://kotu.example` baglantisi, kullaniciyi
 * kendi sitemizde giris yaptirip baska bir sitede birakir.
 *
 * Kabul edilen tek sekil: TEK egik cizgiyle baslayan, uygulama ici yol.
 *   '/buro/teklifler'      -> gecerli
 *   '//kotu.example'       -> RED (protokol-goreli mutlak adres)
 *   'https://kotu.example' -> RED
 *   '/\kotu.example'       -> RED (bazi tarayicilar ters egik cizgiyi duzeltir)
 *
 * Yollar react-router'in gordugu sekildedir (taban yol SOYULMUS); appPath
 * yalniz ham window.location isleri icin gerekir — bkz. src/app-base.ts.
 */

/** Guvenli degilse null doner. */
export const safeNextPath = (raw: string | null | undefined): string | null => {
  if (!raw) return null;
  let value = raw;
  try {
    value = decodeURIComponent(raw);
  } catch {
    // Bozuk yuzde kodlamasi: ham deger uzerinden devam, asagidaki kurallar
    // yine de reddeder.
  }
  if (!value.startsWith('/')) return null;
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  return value;
};

/** Korumalarin giris ekranina gonderirken kullandigi hedef. */
export const loginPathWithNext = (pathname: string, search = ''): string => {
  const target = `${pathname}${search}`;
  if (target === '/' || target === '') return '/giris';
  return `/giris?next=${encodeURIComponent(target)}`;
};
